module.exports = __webpack_public_path__ + "img/glassquality_6.1dacf4d9.png";